import { render, staticRenderFns } from "./IdentityProfile.vue?vue&type=template&id=1a23c5f5&scoped=true"
import script from "./IdentityProfile.vue?vue&type=script&lang=js"
export * from "./IdentityProfile.vue?vue&type=script&lang=js"
import style0 from "./IdentityProfile.vue?vue&type=style&index=0&id=1a23c5f5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a23c5f5",
  null
  
)

export default component.exports